<template>
  <div class="shopping">
    <div class="pao pao1 wow"></div>
    <img src="@/assets/catering4.png" class="pao pao2 wow fadeIn">
    <img src="@/assets/catering3.png" class="pao pao3 wow slideInLeftSelf">
    <!-- <div class="pao pao5 wow slideInLeftSelf"></div>
    <div class="pao pao4 wow slideInRightSelf"></div> -->
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="shopping_content">
      <div class="linear_word">SHOPPING</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">特享购物</div>
      </div>
      <drop class="drop1" cssVal="right: -42px;top: 800px;"></drop>
      <div class="title title1">
        <div>
          <span class="title_span title1_span wow slideInLeftSelf">熊出没旗舰店</span>
        </div>
      </div>
      <div class="dec dec1 wow" data-wow-offset="-100000">以熊出没为主题的商店，主营熊出没周边生活物件，种类丰富，工艺精致，值得收藏与留念。</div>
      <div class="pic pic1 wow" data-wow-offset="-100000"></div>

      <div class="wow fadeInUp logos">
        <img src="@/assets/shopping2.jpg">
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'
import drop from '@/components/drop.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'

export default {
  components: { myMenu, myBottom, drop },
  data() {
    return {

    }
  },
  methods: {
    setWow() {
      $('.dec1, .pic1, .pao1').css('transform', 'translate(-20000px, 0)');
      $('.dec2, .pic2').css('transform', 'translate(-20000px, 0)');
      $('.drops').css('transform', 'translate(-20000px, 0)');
    },
    initWow(zoom) {
      var top = $('.shopping .logos').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            if (box.className.includes('title_span')) {
              var dec = $(box).closest('.title').next('.dec');
              var pic = dec.next('.pic');
              pic.css('transform', 'translate(0, 0)');
              dec.css('transform', 'translate(0, 0)');
              pic.addClass('fadeInDown');
              dec.addClass('fadeInUp');
              $('.drops').css('transform', 'translate(0, 0)');
              $('.drop').addClass('zoomIn')
              setTimeout(() => {
                $('.pao1').css('transform', 'translate(0, 0)');
                $('.pao1').addClass('slideInRightSelf');
              }, 800);
            }
          }
        }
      );
      wow.init();
    },
  },
  mounted() {
    this.setWow();
  }
}
</script>

<style lang="scss" scoped>
.shopping {
  .shopping_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .title {
      font-size: 36px;
      color: #000;
      font-weight: bold;
      margin-top: 70px;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #f39f43;
        vertical-align: middle;
        display: inline-block;
        margin-right: 38px;
      }
      > div {
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        display: inline-block;
      }
    }
    .title2 {
      margin-top: 110px;
    }
    .dec {
      font-size: 26px;
      color: #1e1e1e;
      line-height: 50px;
      text-indent: 2em;
      margin-top: 20px;
      margin-bottom: 60px;
    }
    .dec1 {
      width: 1020px;
    }
    .pic {
      border-radius: 20px;
      overflow: hidden;
    }
    .pic1 {
      border: 1px solid #fff;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 1118px;
      height: 640px;
      background: url('@/assets/shopping1.jpg') no-repeat center;
      background-size: cover;
      margin: 0 auto;
    }
    .pic2 {
      border: 1px solid #fff;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 1118px;
      height: 640px;
      // background: url('@/assets/shopping2.jpg') no-repeat center;
      background-size: cover;
      margin: 0 auto;
    }
    .pic3 {
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      padding: 20px;
      font-size: 0;
      margin-top: 148px;
    }
    .logos{
      background-color: #fff;
      box-shadow: 0 8px 54px 0 rgba(111, 159, 227, .3);
      padding: 20px;
      font-size: 0;
      margin-top: 100px;
    }
  }
  .pao1 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    opacity: 0.5;
    left: 300px;
    top: 850px;
    width: 239px;
    height: 239px;
  }
  .pao2 {
    width: 100%;
    left: 0;
    top: 1260px;
  }
  .pao3 {
    left: 0;
    top: 1200px;
  }
  .pao5 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    position: absolute;
    left: 1458px;
    top: 1928px;
    width: 162px;
    height: 162px;
  }
  .pao4 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    opacity: 0.6;
    right: -50px;
    top: 2930px;
    width: 239px;
    height: 239px;
  }
}
</style>